/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getAnnouncements, showModal, hideModal } from "actions";
import Announcement from "components/widgets/announcements/Announcement";
import * as Alerts from "components/elements/alerts";
import AnnouncementModalBody, {
  AnnouncementModalFooter,
  AnnouncementModalTitle,
} from "components/widgets/announcements/AnnouncementModal";
import { Link } from "react-router-dom";

class AnnouncementsList extends Component {
  state = {
    error: null,
    maxAnnouncementsToShow: this.props.max ? this.props.max : 4,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.props.getAnnouncements(this.onBegin, this.onSuccess, this.onError);
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    this.setState({ error: err.message });
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.renderPopupAnnouncement();
    // this.setState({ announcementListFetched: true });
  };

  selectAnnouncement = (idx) => {
    this.props.hideModal();
    if (idx + 1 > this.props.announcements.data.length) return null;
    let a = this.props.announcements.data[idx];
    // console.log(a.imagePath);
    this.props.showModal({
      modalType: a.type,
      modalTitle: <AnnouncementModalTitle type={a.type} />,
      modalContent: (
        <AnnouncementModalBody
          subject={a.title}
          detail={a.description}
          url={a.url}
          urlName={a.urlName}
          imagePath={a.imagePath}
          spinner={this.props.spinner}
        />
      ),
      modalFooter: (
        <AnnouncementModalFooter
          idx={idx}
          selectAnnouncement={this.selectAnnouncement}
        />
      ),
    });
  };

  renderPopupAnnouncement = () => {

    if (this.props.announcements.data.length === 0) return null;
    let announcement = this.props.announcements.data.find(z => z.isPopup === true);

    if (!announcement)
      return;

    let seenAnnouncement = localStorage.getItem("seenAnnouncement");
    if (seenAnnouncement !== null) {
      if (seenAnnouncement.includes(announcement.id))
        return;
      else
        localStorage.setItem("seenAnnouncement", seenAnnouncement.concat(`,${announcement.id}`))
    } else {
      localStorage.setItem("seenAnnouncement", announcement.id)
    }

    this.props.showModal({
      modalType: announcement.type,
      modalTitle: <AnnouncementModalTitle type={announcement.type} />,
      modalContent: (
        <AnnouncementModalBody
          subject={announcement.title}
          detail={announcement.description}
          url={announcement.url}
          urlName={announcement.urlName}
          imagePath={announcement.imagePath}
          spinner={this.props.spinner}
        />
      )
    });

  }

  renderError = () => {
    if (this.state.error) {
      return (
        <div className="duyuruPaddingArea">
          <div style={{ width: "80%", margin: "auto" }}>
            {Alerts.RedAlert({ content: this.state.error })}
          </div>
        </div>
      );
    } else return null;
  };

  render() {
    let announcements = [];
    if (this.props.announcements.data) {
      announcements = this.props.announcements.data
        .slice(0, this.state.maxAnnouncementsToShow)
        .map((announcement, idx) => {
          return (
            <Announcement
              key={announcement.id}
              announcementId={announcement.id}
              announcementType={announcement.category}
              announcementDate={announcement.date}
              announcementTitle={announcement.title}
              bodyTitle={announcement.bodyTitle}
              bodyDetail={announcement.bodyDetail}
              onClick={() => this.selectAnnouncement(idx)}
              type={announcement.type}
            />
          );
        });
    }

    return (
      <>
        {this.props.showAllEnabled ? (
          <div className="duyuruButton titleArea">
            <div className="duyuruTextArea">
              <div className="duyuruInfo">
                <div className="duyuruAnaBaslik">
                  <Trans desc="Duyurular">10011</Trans>
                </div>
              </div>
            </div>
            <Link to="/announcements">
              <div className="arrow">
                <div className="tumDuyurular">
                  <Trans>10012</Trans>
                </div>
                <span className="iconmford fo-icon-keyboard-arrow-right"></span>
              </div>
            </Link>
          </div>
        ) : null}
        {announcements}
        {this.props.spinner}
        {this.renderError()}
      </>
    );
  }
}

const mapStateToProps = ({ announcements, modal, application }) => {
  return {
    announcements,
    modal,
    application,
  };
};

export default connect(mapStateToProps, {
  getAnnouncements,
  showModal,
  hideModal,
})(containsLongRunningProcess(AnnouncementsList));
